import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Smile({
  className
}) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 30 30",
    className: className,
    children: /*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsxs("g", {
        transform: "translate(-3.639 6.058)",
        children: [/*#__PURE__*/_jsxs("g", {
          transform: "translate(3.639)",
          children: [/*#__PURE__*/_jsx("ellipse", {
            cx: "2.459",
            cy: "2.459",
            rx: "2.459",
            ry: "2.459"
          }), /*#__PURE__*/_jsx("ellipse", {
            cx: "2.459",
            cy: "2.459",
            rx: "2.459",
            ry: "2.459",
            transform: "translate(25.082)"
          })]
        }), /*#__PURE__*/_jsx("path", {
          d: "M85.09,80.22a12.69,12.69,0,0,1-11.571-6.863,1.639,1.639,0,1,1,2.959-1.412,8.441,8.441,0,0,0,3.331,3.57,10.267,10.267,0,0,0,5.281,1.426,9.482,9.482,0,0,0,8.517-4.8,1.639,1.639,0,0,1,2.919,1.494,11.775,11.775,0,0,1-4.6,4.778A13.579,13.579,0,0,1,85.09,80.22Z",
          transform: "translate(-66.441 -56.335)"
        })]
      })
    })
  });
}